import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function WeatherGrowthLinkGroup({ title, intro, links, prefix = "/en", columns = "md:grid-cols-3" }) {
  return (
    <div className="rounded-[1.5rem] border border-border bg-card p-5 md:p-6">
      <h3 className="font-heading text-2xl font-black">{title}</h3>
      {intro && <p className="mt-2 max-w-3xl text-sm leading-7 text-muted-foreground">{intro}</p>}
      <div className={`mt-4 grid gap-3 ${columns}`}>
        {links.map(([label, href, text]) => (
          <Link key={`${label}-${href}`} to={`${prefix}${href}`} className="group rounded-2xl border border-border bg-background/70 p-4 transition hover:border-primary/50 hover:bg-primary/5">
            <span className="flex items-center justify-between gap-3 font-black text-foreground">{label}<ArrowRight className="h-4 w-4 text-primary transition group-hover:translate-x-1" /></span>
            {text && <span className="mt-2 block text-sm leading-6 text-muted-foreground">{text}</span>}
          </Link>
        ))}
      </div>
    </div>
  );
}